export function isProductSaleItem(line: { item?: { type?: string | null } | null }): boolean {
  return line.item?.type === "PRODUTO";
}
